import * as React from "react";
import { useContext, createContext } from "react";
const DrawerContext = createContext(null);
DrawerContext.displayName = "DrawerContext";
const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (context === null) {
    throw new Error("No DrawerContext available.");
  }
  return context;
};
const DrawerProvider = ({
  onClose,
  direction,
  isOpen,
  setIsOpen,
  children
}) => {
  const open = React.useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);
  const close = React.useCallback(() => {
    onClose && onClose();
    setIsOpen(false);
  }, [setIsOpen, onClose]);
  const toggle = React.useCallback(() => {
    setIsOpen((prevValue) => !prevValue);
  }, [setIsOpen]);
  return /* @__PURE__ */ React.createElement(
    DrawerContext.Provider,
    {
      value: {
        direction,
        isOpen,
        open,
        close,
        toggle
      }
    },
    children
  );
};
export {
  DrawerProvider,
  useDrawer
};
//# sourceMappingURL=DrawerContext.js.map
